import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { ReportsList } from '@/components/reports/ReportsList';
import { ReportLoading } from '@/components/reports/ReportLoading';
import { NoReportsFound } from '@/components/reports/NoReportsFound';
import { ReportsPagination } from './ReportsPagination';
import { formatDate, formatTime } from '@/utils/reportFormatters';
import { AdminReportsFilter } from './AdminReportsFilter';

interface AdminContentProps {
  isLoading: boolean;
  reports: any[];
  currentPage: number;
  totalPages: number;
  onReportUpdate: () => void;
  onPageChange: (page: number) => void;
  search: string;
  setSearch: (q: string) => void;
  onSearch: () => void;
  showOtherSubjectsOnly: boolean;
  setShowOtherSubjectsOnly: (b: boolean) => void;
  sortField: string;
  sortDirection: 'asc' | 'desc';
  onSort: (field: string) => void;
  statusFilter: string;
  setStatusFilter: (v: string) => void;
  learningStatusFilter: string;
  setLearningStatusFilter: (v: string) => void;
  submittedOnTimeFilter: string;
  setSubmittedOnTimeFilter: (v: string) => void;
  hoursDeductedFilter: string;
  setHoursDeductedFilter: (v: string) => void;
  teachingDateFrom: Date | undefined;
  setTeachingDateFrom: (d: Date | undefined) => void;
  teachingDateTo: Date | undefined;
  setTeachingDateTo: (d: Date | undefined) => void;
  resetFilters: () => void;
  hasActiveFilters: boolean;
}

export const AdminContent: React.FC<AdminContentProps> = ({
  isLoading,
  reports,
  currentPage,
  totalPages,
  onReportUpdate,
  onPageChange,
  search,
  setSearch,
  onSearch,
  showOtherSubjectsOnly,
  setShowOtherSubjectsOnly,
  sortField,
  sortDirection,
  onSort,
  statusFilter,
  setStatusFilter,
  learningStatusFilter,
  setLearningStatusFilter,
  submittedOnTimeFilter,
  setSubmittedOnTimeFilter,
  hoursDeductedFilter,
  setHoursDeductedFilter,
  teachingDateFrom,
  setTeachingDateFrom,
  teachingDateTo,
  setTeachingDateTo,
  resetFilters,
  hasActiveFilters,
}) => {
  return (
    <Card className="shadow-lg">
      <CardContent className="p-6">
        <AdminReportsFilter
          search={search}
          setSearch={setSearch}
          onSearch={onSearch}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
          learningStatusFilter={learningStatusFilter}
          setLearningStatusFilter={setLearningStatusFilter}
          submittedOnTimeFilter={submittedOnTimeFilter}
          setSubmittedOnTimeFilter={setSubmittedOnTimeFilter}
          hoursDeductedFilter={hoursDeductedFilter}
          setHoursDeductedFilter={setHoursDeductedFilter}
          teachingDateFrom={teachingDateFrom}
          setTeachingDateFrom={setTeachingDateFrom}
          teachingDateTo={teachingDateTo}
          setTeachingDateTo={setTeachingDateTo}
          showOtherSubjectsOnly={showOtherSubjectsOnly}
          setShowOtherSubjectsOnly={setShowOtherSubjectsOnly}
          resetFilters={resetFilters}
          hasActiveFilters={hasActiveFilters}
        />
        {isLoading ? (
          <ReportLoading />
        ) : reports.length > 0 ? (
          <>
            <ReportsList
              reports={reports}
              formatDate={formatDate}
              formatTime={formatTime}
              showTeacherDisplay={true}
              showAdminColumns={true}
              onReportUpdate={onReportUpdate}
              sortField={sortField}
              sortDirection={sortDirection}
              onSort={onSort}
            />
            <ReportsPagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
            />
          </>
        ) : (
          <NoReportsFound />
        )}
      </CardContent>
    </Card>
  );
};
